// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"fe381caf","282":"91e82d35","407":"d4d4176b","499":"0d4f8dac","534":"d2f3f428","866":"b29856ac","914":"fe8570f4","998":"2c6c0373"}[chunkId] + ".chunk.js";
};